import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import { Button, Modal, Space, Table, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import Createseller from "./components/Createclient";
import Editseller from "./components/Editclient";
import { deleteItem, readItems, readUsers } from "@directus/sdk";
import { QRCode } from "react-qrcode-logo";
import { PDFViewer } from "@react-pdf/renderer";
import Pdfqr from "./components/Pdfqr";
import {
  pdf,
  PDFDownloadLink,
  Document,
  Page,
  Text,
  Image,
} from "@react-pdf/renderer";
import { useSelector } from "react-redux";
import validarpermiso from '../../lib/utils';

const Clientsp = (props) => {
  const [datasellers, setDatasellers] = useState([]);
  const [opencreate, setOpencreate] = useState(false);
  const [openupdate, setOpenupdate] = useState(false);
  const [selectseller, setSelectseller] = useState({});
  const [hasPermissionError, setHasPermissionError] = useState(false);
  const permisos = useSelector((state) => state.permisos);

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Direccion",
      dataIndex: "direccion",
      key: "direccion",
    },
    {
      title: "Zona",
      dataIndex: "zona",
      key: "zona",
    },
    {
      title: "Documento",
      dataIndex: "documento",
      key: "documento",
    },
    {
      title: "Acciones",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {validarpermiso("cliente", "delete", permisos) && (
            <Button
              onClick={async () => {
                const directus = await getDirectusClient();
                Modal.confirm({
                  title: "Eliminar usuario",
                  icon: <ExclamationCircleFilled />,
                  content: "¿Desea eliminar este usuario?",
                  onOk() {
                    directus
                      .request(deleteItem("directus_users", record.id))
                      .then(() => getSellers());
                  },
                });
              }}
            >
              Eliminar
            </Button>
          )}
          {validarpermiso("cliente", "update", permisos) && (
            <Button
              onClick={() => {
                setSelectseller(record);
                setOpenupdate(true);
              }}
            >
              Editar
            </Button>
          )}
          <QRCode
            value={record.id.toString()}
            id={record.id}
            logoImage="logoeme.png"
            fgColor="green"
            size={300}
            logoWidth={60}
            qrStyle="squares"
            eyeRadius={[
              [20, 20, 0, 20],
              [20, 20, 20, 0],
              [20, 0, 20, 20],
            ]}
          />
        </Space>
      ),
    },
  ];

  const getSellers = async () => {
    if (!validarpermiso("cliente", "read", permisos)) {
      setHasPermissionError(true);
      return;
    }

    const directus = await getDirectusClient();
    try {
      const res = await directus.request(
        readItems('cliente', {
          
          limit: -1
        })
      );
      setDatasellers(res);
      setHasPermissionError(false);
    } catch (error) {
      console.error('Error fetching clients:', error);
      if (error.response?.status === 403 || error.message?.includes('permission')) {
        setHasPermissionError(true);
        message.error('No tiene permisos para ver los clientes');
      }
    }
  };

  useEffect(() => {
    getSellers();
  }, []);

  const closeCreate = () => {
    setOpencreate(false);
  };

  const closeUpdate = () => {
    setOpenupdate(false);
  };

  const generatePdfsim = () => {
    const doc = <Pdfqr clientes={datasellers} />;
    const asPdf = pdf([]); // {} is important, it resets the previous document
    asPdf.updateContainer(doc);

    asPdf.toBlob().then((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "qrs.pdf";
      link.click();
    });
  };

  return (
    <Layouts>
      {!hasPermissionError ? (
        <>
          {validarpermiso("cliente", "read", permisos) && (
            <Button 
              onClick={() => generatePdfsim()}
              disabled={hasPermissionError}
            >
              Descargar QRs
            </Button>
          )}

          <h3>Usuarios y clientes</h3>
          
          {validarpermiso("cliente", "create", permisos) && (
            <Button
              onClick={() => setOpencreate(true)}
              disabled={hasPermissionError}
            >
              Crear usuario o cliente
            </Button>
          )}

          <Table 
            columns={columns} 
            dataSource={datasellers} 
            rowKey="id"
          />

          {validarpermiso("cliente", "create", permisos) && (
            <Createseller
              getSellers={getSellers}
              opencreate={opencreate}
              closeCreate={closeCreate}
            />
          )}

          {openupdate && selectseller && validarpermiso("cliente", "update", permisos) && (
            <Editseller
              getSellers={getSellers}
              opencreate={openupdate}
              closeUpdate={closeUpdate}
              selectseller={selectseller}
              setSelectseller={setSelectseller}
            />
          )}

          <div style={{display: "none"}}>
            {datasellers.map((c) => (
              <QRCode
                key={c.id}
                value={c.id.toString()}
                id={c.id}
                logoImage="logoeme.png"
                fgColor="green"
                size={300}
                logoWidth={60}
                qrStyle="squares"
                eyeRadius={[
                  [20, 20, 0, 20],
                  [20, 20, 20, 0],
                  [20, 0, 20, 20],
                ]}
              />
            ))}
          </div>
        </>
      ) : (
        <h3>No tiene permisos para ver clientes</h3>
      )}
    </Layouts>
  );
};

export default Clientsp;
